import React from 'react';

const InvestorRelations: React.FC = () => {
    return (
        <div id="app-root" className="relative flex min-h-[100svh] flex-col bg-yellow-50 w-full overflow-x-clip">
            {/* Header */}
            <header className="bg-yellow-50 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between py-3 sm:py-4">
                        <div className="flex items-center space-x-2 sm:space-x-4">
                            <img 
                                src="/images/princonser kids logo.png" 
                                alt="Princonser Kids Logo" 
                                className="h-10 sm:h-12 md:h-14 w-auto"
                            />
                            <h1 className="hidden sm:block text-sm sm:text-base md:text-lg lg:text-xl font-bold text-gray-900 leading-tight">
                                Primera Experiencia Inmersiva de Educación Integral
                            </h1>
                        </div>
                    </div>
                </div>
            </header>

            <main className="flex-1">
                {/* Hero Section */}
                <section 
                    className="relative py-16 sm:py-20 lg:py-24 flex items-center justify-center overflow-hidden"
                    style={{
                        background: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/landingpage/FondoHeroLandingpage.png')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                    <div className="relative z-10 max-w-7xl w-full px-4 sm:px-6 lg:px-8 text-center">
                        <div className="mb-8 sm:mb-12">
                            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8 leading-tight drop-shadow-2xl">
                                <span className="text-yellow-300">Investor Relations</span><br/>
                                <span className="text-white">Princonser Kids</span>
                            </h1>
                            <p className="text-lg sm:text-xl md:text-2xl text-gray-200 mb-8 sm:mb-12 max-w-4xl mx-auto leading-relaxed drop-shadow-lg px-2">
                                Convertir la Sabiduría y el Propósito en algo práctico y medible
                            </p>
                        </div>
                    </div>
                </section>

                {/* Main Content Section */}
                <section className="py-12 sm:py-16 lg:py-20 bg-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center mb-12 sm:mb-16">
                            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-6 sm:mb-8">
                                Formar niños sabios con 
                                <span className="text-blue-600"> propósito</span>
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 mb-12 sm:mb-16">
                            {/* Left Column - Business Model */}
                            <div className="space-y-6 sm:space-y-8">
                                <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl border-l-4 border-green-400">
                                    <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6">
                                        📈 Modelo de Negocio
                                    </h3>
                                    <div className="space-y-4 sm:space-y-6 text-gray-700">
                                        <div className="bg-white/50 rounded-xl p-4 sm:p-6">
                                            <h4 className="text-lg sm:text-xl font-bold text-green-800 mb-3 sm:mb-4">
                                                🌟 Horizontal: La Experiencia Educativa Princonser
                                            </h4>
                                            <p className="text-base sm:text-lg leading-relaxed mb-3">
                                                La base del modelo es una experiencia continua de aprendizaje que combina filosofía, juego y propósito. Cada niño avanza a través de un viaje formativo donde lectura, debate, reflexión y acción se integran en un mismo sistema.
                                            </p>
                                            <p className="text-base sm:text-lg leading-relaxed">
                                                Un ecosistema donde todo lo que el niño aprende en el libro, se refuerza en el canal, se vive en la App y se amplifica a través de los mentores certificados.
                                            </p>
                                        </div>
                                        
                                        <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-3 sm:mb-4">
                                            Las Cuatro Verticales de Ingreso:
                                        </h4>
                                        
                                        <div className="space-y-3 sm:space-y-4">
                                            <div className="flex items-start space-x-3">
                                                <div className="w-6 h-6 bg-green-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                                    <span className="text-white text-sm">1</span>
                                                </div>
                                                <div>
                                                    <p className="text-base sm:text-lg leading-relaxed font-semibold">
                                                        📚 Venta de Libros (Producto físico + digital)
                                                    </p>
                                                    <p className="text-sm sm:text-base text-gray-600">
                                                        Serie de libros y guías prácticas para niños y padres. Incluye acceso al ecosistema digital (App + insignias + comunidad). Es el primer punto de contacto y principal puerta de entrada a la experiencia.
                                                    </p>
                                                </div>
                                            </div>
                                            
                                            <div className="flex items-start space-x-3">
                                                <div className="w-6 h-6 bg-green-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                                    <span className="text-white text-sm">2</span>
                                                </div>
                                                <div>
                                                    <p className="text-base sm:text-lg leading-relaxed font-semibold">
                                                        📺 Canal de YouTube (Contenido + Comunidad + Awareness)
                                                    </p>
                                                    <p className="text-sm sm:text-base text-gray-600">
                                                        Contenido educativo y de entretenimiento para niños y familias. Monetización por publicidad, alianzas y licencias de contenido. Sirve como canal de adquisición orgánica y posicionamiento de marca educativa global.
                                                    </p>
                                                </div>
                                            </div>
                                            
                                            <div className="flex items-start space-x-3">
                                                <div className="w-6 h-6 bg-green-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                                    <span className="text-white text-sm">3</span>
                                                </div>
                                                <div>
                                                    <p className="text-base sm:text-lg leading-relaxed font-semibold">
                                                        🎮 App Debate (Juego educativo y plataforma de sabiduría)
                                                    </p>
                                                    <p className="text-sm sm:text-base text-gray-600">
                                                        Juego interactivo que enseña pensamiento crítico, argumentación y valores. Modelo freemium con suscripción mensual/anual y recompensas desbloqueables. Genera recurrencia, datos de uso y retención dentro del ecosistema.
                                                    </p>
                                                </div>
                                            </div>
                                            
                                            <div className="flex items-start space-x-3">
                                                <div className="w-6 h-6 bg-green-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                                    <span className="text-white text-sm">4</span>
                                                </div>
                                                <div>
                                                    <p className="text-base sm:text-lg leading-relaxed font-semibold">
                                                        🏫 Franquicia / Licencia Educativa
                                                    </p>
                                                    <p className="text-sm sm:text-base text-gray-600">
                                                        Modelo B2B para colegios y docentes emprendedores. Incluye capacitación, materiales y certificación como Tutor Princonser. Escalable, con ingresos anuales por licencia y regalías. Funge como motor de crecimiento global con efecto red (mentores, clubes y colegios aliados).
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column - Metrics */}
                            <div className="space-y-6 sm:space-y-8">
                                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl border-l-4 border-purple-400">
                                    <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6">
                                        📊 Métricas Clave
                                    </h3>
                                    
                                    {/* Investigación Varkey Foundation */}
                                    <div className="mb-6 sm:mb-8">
                                        <div className="bg-white/50 rounded-xl p-4 sm:p-6 mb-4">
                                            <h4 className="text-lg sm:text-xl font-bold text-purple-800 mb-3">
                                                📈 Investigación de Mercado Global
                                            </h4>
                                            <p className="text-sm sm:text-base text-gray-600 mb-3">
                                                <strong>Varkey Foundation (2017). Global Parents' Survey. London, Varkey Foundation.</strong>
                                            </p>
                                            <p className="text-sm sm:text-base text-gray-600 mb-3">
                                                En una encuesta realizada a más de 27,500 padres en 29 países, se encontraron las siguientes métricas clave:
                                            </p>
                                            <div className="space-y-2 sm:space-y-3">
                                                <div className="flex items-start space-x-2">
                                                    <span className="text-purple-600 font-bold">•</span>
                                                    <p className="text-sm sm:text-base text-gray-700">
                                                        Los padres están profundamente divididos sobre si los estándares de educación han mejorado o empeorado en los últimos diez años: <strong>el 40% dice que han mejorado y el 37% dice que han empeorado</strong>.
                                                    </p>
                                                </div>
                                                <div className="flex items-start space-x-2">
                                                    <span className="text-purple-600 font-bold">•</span>
                                                    <p className="text-sm sm:text-base text-gray-700">
                                                        <strong>Conseguir un empleo y tener una carrera exitosa es la preocupación más profunda</strong> que los padres tienen sobre el futuro de su hijo.
                                                    </p>
                                                </div>
                                                <div className="flex items-start space-x-2">
                                                    <span className="text-purple-600 font-bold">•</span>
                                                    <p className="text-sm sm:text-base text-gray-700">
                                                        Si su hijo es feliz y disfruta de la escuela es la preocupación principal que los padres tienen sobre su hijo mientras está en la escuela, <strong>siendo la salud mental la segunda preocupación más importante</strong>.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Validación de Mercado */}
                                    <div className="bg-white/50 rounded-xl p-4 sm:p-6">
                                        <h4 className="text-lg sm:text-xl font-bold text-purple-800 mb-3">
                                            ✅ Validación de Mercado y Producto
                                        </h4>
                                        <p className="text-sm sm:text-base text-gray-600 mb-3">
                                            Realizamos un programa piloto internacional en el que distribuimos el primer libro de la serie Princonser Kids a familias de cinco países.
                                        </p>
                                        <p className="text-sm sm:text-base text-gray-600 mb-3">
                                            Los resultados confirmaron una validación contundente tanto en el segmento familiar como educativo:
                                        </p>
                                        <div className="space-y-2 sm:space-y-3">
                                            <div className="flex items-start space-x-2">
                                                <span className="text-green-600 font-bold">•</span>
                                                <p className="text-sm sm:text-base text-gray-700">
                                                    <strong>100% de los padres calificaron la experiencia con 5/5 en el Net Promoter Score (NPS)</strong>, reflejando una satisfacción y disposición total a recomendar el programa.
                                                </p>
                                            </div>
                                            <div className="flex items-start space-x-2">
                                                <span className="text-green-600 font-bold">•</span>
                                                <p className="text-sm sm:text-base text-gray-700">
                                                    <strong>100% de los maestros y directores consultados manifestaron interés en implementar la experiencia Princonser Kids dentro de sus escuelas</strong>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Value Proposition Section */}
                        <div className="mb-12 sm:mb-16">
                            <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl border-l-4 border-blue-400 max-w-4xl mx-auto">
                                <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 text-center">
                                    🎯 Nuestra Propuesta de Valor
                                </h3>
                                <div className="space-y-4 sm:space-y-6 text-gray-700 text-center">
                                    <p className="text-base sm:text-lg leading-relaxed font-semibold text-blue-800">
                                        Convertir la Sabiduría y el Propósito en algo práctico y medible
                                    </p>
                                    <p className="text-base sm:text-lg leading-relaxed">
                                        <strong>Misión:</strong> Formar niños sabios con propósito
                                    </p>
                                    <p className="text-base sm:text-lg leading-relaxed">
                                        <strong>Princonser Kids</strong> es una plataforma educativa integral basada en sabiduría, construida sobre una horizontal de experiencia educativa y cuatro verticales de monetización.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Documents Section */}
                        <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl mb-12 sm:mb-16">
                            <div className="text-center mb-8 sm:mb-12">
                                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4 sm:mb-6">
                                    📄 Documentos de Inversión
                                </h3>
                                <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
                                    Accede a nuestros documentos clave para tomar una decisión informada
                                </p>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
                                <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200">
                                    <div className="text-center">
                                        <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                            <span className="text-2xl sm:text-3xl">📊</span>
                                        </div>
                                        <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">Pitch Deck</h4>
                                        <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
                                            Presentación ejecutiva con visión, mercado y proyecciones
                                        </p>
                                        <div className="space-y-2 sm:space-y-3">
                                            <button 
                                                onClick={() => window.open('/documents/Investors/Pitch Deck - Princonser Kids (v.9).pdf', '_blank')}
                                                className="w-full bg-blue-600 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-300"
                                            >
                                                Descargar PDF ES
                                            </button>
                                            <button 
                                                onClick={() => window.open('/documents/Investors/Pitch Deck - Princonser Kids (v.1)EN.pdf', '_blank')}
                                                className="w-full bg-blue-500 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-lg font-semibold hover:bg-blue-600 transition-colors duration-300"
                                            >
                                                Descargar PDF EN
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200">
                                    <div className="text-center">
                                        <div className="w-12 h-12 sm:w-16 sm:h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                            <span className="text-2xl sm:text-3xl">💰</span>
                                        </div>
                                        <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">Plan Financiero</h4>
                                        <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
                                            Proyecciones financieras y modelo de ingresos detallado
                                        </p>
                                        <button 
                                            onClick={() => window.open('/documents/Investors/Princonser Kids - Modelo Financiero (v.4).xlsx', '_blank')}
                                            className="w-full bg-green-600 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors duration-300"
                                        >
                                            Descargar Excel
                                        </button>
                                    </div>
                                </div>

                                <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200">
                                    <div className="text-center">
                                        <div className="w-12 h-12 sm:w-16 sm:h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                            <span className="text-2xl sm:text-3xl">🏢</span>
                                        </div>
                                        <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">Business Model</h4>
                                        <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
                                            Estrategia de negocio y modelo de operación
                                        </p>
                                        <button 
                                            onClick={() => window.open('/documents/Investors/Plan de Negocios (v.8).pdf', '_blank')}
                                            className="w-full bg-purple-600 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors duration-300"
                                        >
                                            Descargar PDF
                                        </button>
                                    </div>
                                </div>

                                <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200">
                                    <div className="text-center">
                                        <div className="w-12 h-12 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                            <span className="text-2xl sm:text-3xl">🌐</span>
                                        </div>
                                        <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-2 sm:mb-3">Demostración de la web</h4>
                                        <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
                                            Presentación de la plataforma web y funcionalidades
                                        </p>
                                        <button 
                                            onClick={() => window.open('/documents/Investors/IT WEB V.1.pdf', '_blank')}
                                            className="w-full bg-orange-600 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors duration-300"
                                        >
                                            Descargar PDF
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Contact Section */}
                <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-r from-blue-600 to-purple-600">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center mb-8 sm:mb-12">
                            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
                                🤝 Conectemos
                            </h2>
                            <p className="text-lg sm:text-xl text-gray-200 max-w-3xl mx-auto">
                                Estamos buscando socios estratégicos que compartan nuestra visión de transformar la educación infantil
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12">
                            {/* Contact Information */}
                            <div className="bg-white/10 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10">
                                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8">
                                    📧 Información de Contacto
                                </h3>
                                <div className="space-y-4 sm:space-y-6">
                                    <div className="flex items-center space-x-4">
                                        <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-full flex items-center justify-center">
                                            <span className="text-white text-lg sm:text-xl">📧</span>
                                        </div>
                                        <div>
                                            <p className="text-white font-semibold text-base sm:text-lg">Email</p>
                                            <div className="space-y-1">
                                                <a 
                                                    href="mailto:director@princonserkids.com" 
                                                    className="text-yellow-300 hover:text-yellow-200 transition-colors duration-300 text-sm sm:text-base block"
                                                >
                                                    director@princonserkids.com
                                                </a>
                                                <a 
                                                    href="mailto:admin@princonserkids.com" 
                                                    className="text-yellow-300 hover:text-yellow-200 transition-colors duration-300 text-sm sm:text-base block"
                                                >
                                                    admin@princonserkids.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center space-x-4">
                                        <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-full flex items-center justify-center">
                                            <span className="text-white text-lg sm:text-xl">💼</span>
                                        </div>
                                        <div>
                                            <p className="text-white font-semibold text-base sm:text-lg">LinkedIn</p>
                                            <a 
                                                href="https://linkedin.com/company/princonserkids" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="text-yellow-300 hover:text-yellow-200 transition-colors duration-300 text-sm sm:text-base"
                                            >
                                                linkedin.com/company/princonserkids
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Form */}
                            <div className="bg-white/10 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10">
                                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8">
                                    💬 Formulario de Contacto
                                </h3>
                                <form className="space-y-4 sm:space-y-6">
                                    <div>
                                        <input 
                                            type="text" 
                                            placeholder="Nombre completo" 
                                            className="w-full px-4 py-3 sm:px-6 sm:py-4 rounded-lg bg-white/90 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                        />
                                    </div>
                                    <div>
                                        <input 
                                            type="email" 
                                            placeholder="Correo electrónico" 
                                            className="w-full px-4 py-3 sm:px-6 sm:py-4 rounded-lg bg-white/90 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                        />
                                    </div>
                                    <div>
                                        <input 
                                            type="text" 
                                            placeholder="Empresa/Organización" 
                                            className="w-full px-4 py-3 sm:px-6 sm:py-4 rounded-lg bg-white/90 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                        />
                                    </div>
                                    <div>
                                        <textarea 
                                            placeholder="Cuéntanos sobre tu interés en invertir..." 
                                            rows={4}
                                            className="w-full px-4 py-3 sm:px-6 sm:py-4 rounded-lg bg-white/90 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-yellow-400 resize-none"
                                        ></textarea>
                                    </div>
                                    <button 
                                        type="submit"
                                        className="w-full bg-yellow-400 text-gray-800 px-6 py-3 sm:px-8 sm:py-4 rounded-lg font-bold text-lg hover:bg-yellow-300 transition-colors duration-300"
                                    >
                                        Enviar Mensaje
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            
            {/* Footer */}
            <footer className="bg-gray-900 text-white py-8 sm:py-12 relative">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
                        <div className="md:col-span-2">
                            <div className="flex items-center mb-4 sm:mb-6">
                                <img 
                                    src="/images/princonser kids logo.png" 
                                    alt="Princonser Kids Logo" 
                                    className="h-10 sm:h-12 w-auto mr-3 sm:mr-4"
                                />
                                <div>
                                    <h3 className="text-lg sm:text-xl font-bold text-white">Princonser Kids</h3>
                                    <p className="text-yellow-300 text-xs sm:text-sm">Educación Integral</p>
                                </div>
                            </div>
                            <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                                Convertir la Sabiduría y el Propósito en algo práctico y medible. Formando niños sabios con propósito a través de una experiencia educativa integral que combina filosofía, juego y propósito.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                                <div className="bg-yellow-400 text-black px-3 py-2 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-bold">
                                    🧠 Sabiduría Práctica
                                </div>
                                <div className="bg-green-400 text-black px-3 py-2 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-bold">
                                    🎯 4 Verticales de Ingreso
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="border-t border-gray-700 pt-6 sm:pt-8">
                        <div className="flex flex-col md:flex-row justify-between items-center">
                            <div className="text-gray-400 text-xs sm:text-sm mb-3 md:mb-0">
                                <p>&copy; 2024 Princonser Kids. Todos los derechos reservados.</p>
                                <p className="mt-1">Formando niños sabios con propósito.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default InvestorRelations;
